import React, {Component} from 'react';
import EditPositionLoanableView from "./EditPositionLoanableView";
import {Growl} from "primereact/growl";
import {validateNumberIntegersDecimals} from "../../../../utils/formatters/Numbers";
import {CatalogDateService} from "../../../../service/catalog/CatalogDateService";
import {RestrictionsService} from "../../../../service/ptm/RestrictionsService";
import {CaptureLoanableValuesService} from "../../../../service/ptm/CaptureLoanableValuesService";
import {Button} from "primereact/button";
import {calculateRewardContainer, withoutComma} from "../../../../utils/calculate/Amount";
import {dateDDMMYY} from '../../../../utils/formatters/Date';


export default class EditPositionLoanableContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        this.catalogDateService = new CatalogDateService();
        this.restrictionsService = new RestrictionsService();
        this.captureLoanableValuesService = new CaptureLoanableValuesService();
        this.accountDropDown = React.createRef();
        this.getMaxValueDate = this.getMaxValueDate.bind(this);
        this.getRestrictions = this.getRestrictions.bind(this);
        this.getExpirationDate = this.getExpirationDate.bind(this);
        this.getRestrictionsPosture = this.getRestrictionsPosture.bind(this);
        this.initializePositionData = this.initializePositionData.bind(this);
        this.getTasaMinPlazoMax = this.getTasaMinPlazoMax.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            selectedPosition: this.props.location.state.selectedPosition,
            positionData: {},
            tasaPlazo: this.getTasaMinPlazoMax(),
            maxValueDate: this.getMaxValueDate(),
            restrictionsPosture: this.getRestrictionsPosture(),
            listRestrictions: this.getRestrictions(),

            displayDialog: false,
            isLoading: false,
        };

        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeRestrictions = this.onChangeRestrictions.bind(this);
        this.addPosition = this.addPosition.bind(this);
        this.getErrors = this.getErrors.bind(this);
        this.returnCaptureValuesPage = this.returnCaptureValuesPage.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.modifyRestrictions = this.modifyRestrictions.bind(this);
        this.openRestrictionsDialog = this.openRestrictionsDialog.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        this.initializePositionData(this.props.location.state.selectedPosition);

        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    initializePositionData() {
        let positionDataSelected = this.props.location.state.selectedPosition;
        let positionDataAux = positionDataSelected;
        positionDataAux['banderaOtc'] = false;
        positionDataAux['vigencia'] = positionDataSelected['tipoVigencia'] === '0' ? 'D' : 'S';
        positionDataAux['tasa'] = positionDataSelected['tasa'] * 100;
        positionDataAux['sobreTasa'] = positionDataSelected['sobreTasa'] * 100;
        positionDataAux['fechaValor'] = dateDDMMYY(positionDataSelected['fecValor']);
        this.setState({positionData: positionDataAux});
        this.getRestrictionsPosture();
        this.getExpirationDate(this.props.location.state.selectedPosition);
    }

    getTasaMinPlazoMax() {
        this.loading(true);
        this.captureLoanableValuesService.getListPositionsCaptureValues()
            .then(listPositions => {
                let positionDataAux = this.state.positionData;
                let positionFiltered = listPositions.filter(elem =>
                    elem['IdEmision'].toString() === positionDataAux.idEmision &&
                    elem['Cuenta'].toString() === positionDataAux.cuenta)[0];
                if(positionFiltered !== undefined) {
                    positionDataAux['tasaMin'] = positionFiltered['TasaMinima'];
                    positionDataAux['plazoMax'] = positionFiltered['PlazoMaximo'];
                    positionDataAux['disponible'] = positionFiltered['PosDisponible'];
                }
                this.setState({
                    positionData: positionDataAux,
                });
                this.loading(false);
            });
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    getMaxValueDate() {
        this.loading(true);
        this.catalogDateService.getMaxValueDate().then(
            valueDate => {
                let positionDataAux = this.state.positionData;
                positionDataAux['maxValueDate'] = new Date(valueDate[0])
                this.setState({
                    positionData: positionDataAux,
                });
                this.loading(false);
            });
    }

    getRestrictions() {
        this.loading(true);
        this.restrictionsService.getRestrictions()
            .then(resp => {
                let restrictionsStr = '';
                let positionData = this.state.positionData;

                resp.payload.forEach(item => {
                    restrictionsStr = restrictionsStr.concat(', ' + item.nombre)
                });
                positionData['valuesAccepted'] = restrictionsStr.substring(1);

                this.setState({
                    listRestrictions: resp.payload,
                    positionData: positionData,
                });
                this.getRestrictionsPosture();
                this.loading(false);
            });
    }

    getRestrictionsPosture() {
        let folio = this.props.location.state.selectedPosition.folio;
        this.loading(true);
        this.restrictionsService.getRestrictionsPosture(folio)
            .then(resp => {
                let positionData = this.state.positionData;
                let restrictionsStr = '';
                let restrictionsAux = '';
                let respAux = resp;

                if (resp.length === 0) {
                    positionData['restricciones'] = "TODOS";
                    respAux = this.state.listRestrictions ? this.state.listRestrictions : [];
                } else {
                    resp.forEach(item => {
                        restrictionsStr = restrictionsStr.concat(', ' + item.nombre)
                        restrictionsAux = restrictionsAux.concat(',' + item.id + '|' + item.tipo);
                    });
                    positionData['restricciones'] = restrictionsAux.substring(2);
                    positionData['valuesAccepted'] = restrictionsStr.substring(1);
                }

                this.setState({
                    restrictionsPosture: respAux,
                    positionData: positionData,
                });
                this.loading(false);
            });
    }

    getExpirationDate(positionData) {
        this.loading(true);
        let plazo = positionData.plazo ?
            positionData.plazo : this.state.positionData.plazo;
        let fecValor = positionData.fecValor ?
            positionData.fecValor : this.state.positionData.fecValor;
        this.catalogDateService.getMaturityDate(withoutComma(plazo.toString()), fecValor)
            .then(dateInfo => {
                let positionDataAux = this.state.positionData;
                positionDataAux['fecVence'] = dateInfo[0];
                positionDataAux['validDate'] = dateInfo[1] === 1;
                this.setState({
                    positionData: positionDataAux
                });
            });
        this.loading(false);
    }

    onChangeRestrictions(event) {
        this.setState({restrictionsPosture: event.value});
    }


    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeText(event) {
        let {name, value, id} = event.target;
        value = value ? value : '';
        let positionDataAux = this.state.positionData;
        positionDataAux[name] = value;
        let numValue = Number(withoutComma(value));

        if (name === "tasa" || name === "sobreTasa" || name === "premioMin") {
            positionDataAux[name] = validateNumberIntegersDecimals(numValue, id, 2);
        } else if (name === "plazo") {
            if (value !== '' && value !== '0') {
                this.getExpirationDate(positionDataAux)
            }
        } else if (name === "fecValor") {
            if (positionDataAux['plazo'] !== '' && positionDataAux['plazo'] !== '0') {
                this.getExpirationDate(positionDataAux);
            }
        }

        this.setState({positionData: positionDataAux,})
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    addPosition() {
        this.loading();
        let msgError = this.getErrors();
        if (msgError === '') {
            this.captureLoanableValuesService.updateLoanableValues(this.state.positionData)
                .then(resp => {
                    if (resp.message === 'Success') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'La solicitud se ha actualizado correctamente',
                        };
                        this.returnCaptureValuesPage(message);
                    } else if (resp.message !== '' && resp.message !== 'Success') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: resp.message,
                        };
                        this.returnCaptureValuesPage(message);

                    } else if (resp.error !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                    }
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: msgError});
        }
    }

    getErrors() {
        let msgError = '';
        let premio = calculateRewardContainer(
            this.state.positionData.cantidad,
            this.state.positionData.precio,
            this.state.positionData.tasa,
            this.state.positionData.plazo
        );
        if (this.state.positionData.cantidad === '' || this.state.positionData.cantidad === '0') {
            msgError = 'La cantidad no puede ser cero o vacía';
        } else if (this.state.positionData.tasa === '') {
            msgError = 'La tasa no puede ser vacía';
        } else if (this.state.positionData.plazo === '' || this.state.positionData.plazo === '0') {
            msgError = 'El plazo no puede ser cero o vacío';
        } else if ((this.state.positionData.plazo === '') || (!this.state.positionData.validDate)) {
            msgError = 'El Plazo es incorrecto ya que el vencimiento no puede ser sábado, domingo o en día festivo';
        } else if (Number(withoutComma(this.state.positionData.premioMin.toString())) >
            Number(withoutComma(premio))) {
            msgError = 'El premio mínimo debe ser menor al premio calculado';
        } else if (withoutComma(premio).length > 16) {
            msgError = 'Importe de Premio excede longitud le sugerimos revisar la tasa'
        } else if (withoutComma(this.state.positionData.tasa) <
            withoutComma(this.state.positionData.tasaMin)) {
            msgError = "La tasa debe ser mayor o igual a la tasa mínima";
        }
        return msgError;
    }

    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnCaptureValuesPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }


    modifyRestrictions() {
        let restrictionsStr = '';
        let positionDataAux = this.state.positionData;
        let displayDialogAux = true;

        if (this.state.restrictionsPosture.length === 0) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccionar al menos una restricción del portafolio default'
            });
        } else if (this.state.restrictionsPosture.length === this.state.listRestrictions.length) {
            this.state.restrictionsPosture.forEach(item => {
                restrictionsStr = restrictionsStr.concat(', ' + item.nombre)
            });
            positionDataAux['restricciones'] = 'TODOS';
            positionDataAux['valuesAccepted'] = restrictionsStr.substring(1);
            displayDialogAux = false;
        } else {
            let restrictionsAux = ' ';
            this.state.restrictionsPosture.forEach(item => {
                restrictionsStr = restrictionsStr.concat(', ' + item.nombre);
                restrictionsAux = restrictionsAux.concat(',' + item.id + '|' + item.tipo);
            });
            positionDataAux['restricciones'] = restrictionsAux.substring(2);
            positionDataAux['valuesAccepted'] = restrictionsStr.substring(1);
            displayDialogAux = false;
        }
        this.setState({
            positionData: positionDataAux,
            displayDialog: displayDialogAux,
        });
    }

    onHideDialog() {
        this.setState({
            displayDialog: false,
        });
    }

    openRestrictionsDialog() {
        this.setState({
            displayDialog: true,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let dialogHeader = <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-6">
                <h2 className={"secondary-text"}>Modificar restricciones</h2>
            </div>
            <div className="p-col-12 p-md-3 p-lg-3">
                <Button label="Regresar" onClick={this.onHideDialog}
                        className="p-button-secondary"/>
            </div>
            <div className="p-col-12 p-md-3 p-lg-3">
                <Button label="Guardar" onClick={this.modifyRestrictions}/>
            </div>
        </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            positionData, isLoading, restrictionsPosture,
            listRestrictions, displayDialog
        } = this.state

        return (
            <EditPositionLoanableView
                positionData={positionData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                restrictionsPosture={restrictionsPosture}
                listRestrictions={listRestrictions}
                dialogHeader={dialogHeader}
                displayDialog={displayDialog}
                loading={this.loading}
                onChangeText={this.onChangeText}
                onChangeDropDown={this.onChangeDropDown}
                onChangeRestrictions={this.onChangeRestrictions}
                onChangeRadio={this.onChangeRadio}
                onHideDialog={this.onHideDialog}
                addPosition={this.addPosition}
                returnCaptureValuesPage={this.returnCaptureValuesPage}
                redirectAddInstrument={this.redirectAddInstrument}
                getExpirationDate={this.getExpirationDate}
                openRestrictionsDialog={this.openRestrictionsDialog}
            />
        );
    }
}
